import React, { useContext } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "./context/TestContext";
import Resultados from "../data/Resultados";
import "./assets/estilos.css"


const Resultado = () => {

    const { puntaje } = useContext(Context);

    let titulo = "";
    let itemKey = 0;
    let img = "";

    let rango = (puntaje === 5) ? 1
        : (puntaje > 5 && puntaje <= 10) ? 2
            : (puntaje > 10 && puntaje <= 15) ? 3
                : (puntaje > 15 && puntaje <= 20) ? 4
                    : 5;

    Resultados.map((item) => {
        if (item.id === rango) {
            titulo = item.title;
            itemKey = item.id;
            img = item.imagen;
        }
        return item
    });


    return (
        <>
             <Container>
                <Row>

                    <Col>
                        <div className="contenedorElemento">
                            <Card>
                                <Card.Img variant="top" src={img} key={itemKey} />
                                <Card.Body>
                                    <div className="d-grid gap-2">
                                        <h4>Puntaje obtenido: {puntaje}</h4>
                                        <h2>{titulo}</h2>
                                        <p>El TOC es un trastorno mental en el que las personas tienen pensamientos, sentimientos, ideas, sensaciones (obsesiones) y comportamientos repetitivos e indeseables que los impulsan a hacer algo una y otra vez (compulsiones).<br /><br /> Más de 100 millones de personas en todo el mundo sufren de Trastorno Obsesivo Compulsivo (TOC).<br /><br /> Normalicemos el cuidado de la Salud Mental. Conversemos más de TOC <b>#ConversemosdeSaludMental</b>.<br /><br /> <b>Te invitamos a revisar el test de síntomas de TOC preparado por nuestros especialistas. <a href="https://web.cetep.cl/test_salud_mental/test-de-sintomas-de-trastorno-obsesivo-compulsivo/" target="_blank">Realizar Test</a></b>.<br /><br /> En Centro Médico Cetep encuentras los mejores profesionales para tu Salud Mental y Bienestar. Te invitamos a acceder a nuestro sistema de reserva de hora online en el siguiente link: <a  href="https://web.cetep.cl/reservar-hora-cetep/" target="_blank">Reserva tu hora</a></p>

                                        <Link to={`/formulario`}>
                                            <Button variant="success" size="lg" className="botonParticipar">Participar</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                </Row>
            </Container>


        </>

    );
}

export default Resultado;
